/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./../style/footer.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
        <div className="logo">
          <img src="/images/logo-main.svg" alt="Logo" className="logo-image" />
        </div>
          <p>Strengthen your online presence with a reliable, easy-to-use listing platform.</p>
          
          <div className="social-links">
            <a href="#" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="#" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="#" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="#" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h4>For Businesses</h4>
          <ul>
            <li>
              <a href="#">Add Your Business</a>
            </li>
            <li>
              <a href="#">Login</a>
            </li>
            <li>
              <a href="#">Create Account</a>
            </li>
            <li>
              <a href="#">Listing Guidelines</a>
            </li>
          </ul>
        </div>


        <div className="footer-links">
          <h4>Popular Categories</h4>
          <ul>
            <li>
              <a href="#">Restaurants</a>
            </li>
            <li>
              <a href="#">Salons & Beauty</a>
            </li>
            <li>
              <a href="#">Clinics & Hospitals</a>
            </li>
            <li>
              <a href="#">Electricians</a>
            </li>
               <li>
              <a href="#">Plumbers</a>
            </li>
               <li>
              <a href="#">Packers & Movers</a>
            </li>
               <li>
              <a href="#">CA & Tax Consultants</a>
            </li>
               <li>
              <a href="#">IT Services</a>
            </li>
          </ul>
        </div>
                <div className="footer-links">
          <h4>Legal & Policies</h4>
          <ul>
            <li>
              <a href="#">Terms of Use</a>
            </li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
            <li>
              <a href="#">Content & Review Policy</a>
            </li>
          
          </ul>
        </div>

        <div className="footer-links">
          <h4>Resources</h4>
          <ul>
            <li>
              <a href="#">Blog</a>
            </li>
            <li>
              <a href="#">FAQ</a>
            </li>
            <li>
              <a href="#">Help Center</a>
            </li>
              <li>
              <a href="#">Sitemap</a>
            </li>
          </ul>
        </div>
 
      </div>
      <div className="footer-bottom">
        <p>
          Copyright © 2024 Drop-Your-Business       
        </p>
      </div>
    </footer>
  );
};

export default Footer;
